import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Card_1 from '../components/Card_1';
import { ArrowLeft, HeartPlus } from 'lucide-react';
import MobileNav from '../components/MobileNav';

export default function Favorites() {
    const location = useLocation();
    const { category } = location.state || {};

    const [videos, setVideos] = useState([]);

    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem('LK_Favorites')) || [];
        setVideos(stored);
    }, []);

    return (
       <div>
         <section className='container'>
            <div className='d-flex flex-row align-items-center gap-2 my-4'>
                <ArrowLeft
                    size={'30px'}
                    color='white'
                    onClick={() => window.history.back()}
                    style={{ cursor: 'pointer' }}
                />
                <h2 className='pink'>Favorites</h2>
            </div>

            {/* <div className='video-grid'>
                {videos.length > 0 ? (
                    videos.map((video, VidIndex) => (
                        <Card_1 video={video} channel={videos} key={VidIndex} />
                    ))
                ) : (
                    <div className='text-center mt-5 w-100 bg-white'>
                        <HeartPlus size={48} color='var(--main-pink)' className='mb-3 text-muted' />
                        <h2 className='text-light' >No Favorites</h2>
                        <p className='text-light' >Go to a category and click on the heart to add videos to your favorites.</p>
                    </div>
                )}
            </div> */}


            {videos.length > 0 ? (
                <div className='video-grid'>
                    {videos.map((video, VidIndex) => (
                        <Card_1 video={video} channel={videos} key={VidIndex} />
                    ))}
                </div>
            ) : (
                <div className='text-center mt-5 w-100 '>
                    <HeartPlus size={48} color='var(--main-pink)' className='mb-3 text-muted' />
                    <h2 className='text-light'>No Favorites</h2>
                    <p className='text-light'>Go to a category and click on the heart to add videos to your favorites.</p>
                </div>
            )}



        </section >
        <MobileNav/>
       </div>
    );
}
